import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import './AboutUsPage.css';
import IconAboutSvg from '../../components/IconAboutSvg/IconAboutSvg';

const AboutUsPage = () => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'AboutPage.title' });
  const descrptionSection = intl.formatMessage({ id: 'AboutPage.descrptionSection' });
  const descrptionSection1 = intl.formatMessage({ id: 'AboutPage.descrptionSection1' });
  const descrptionSection2 = intl.formatMessage({ id: 'AboutPage.descrptionSection2' });

  return (
    <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>

    <Page title="" scrollingDisabled={false}>
      <div>
          <div className="aboutpageContainer">
            <div className="aboutpageDescriptionContainer">
              <h2>{title}</h2>
              {/* <p>{descrptionSection}</p>
              <p>{descrptionSection1}</p>
              <p>{descrptionSection2}</p> */}
              <div className='about_sub_title'>
                <p>{intl.formatMessage({id:'AboutPage.subTitle'})}</p>
                <p>{intl.formatMessage({id:'AboutPage.subTitle.description'})}</p>
                <p>{intl.formatMessage({id:'AboutPage.subTitle.description1'})}</p>
              </div>
              <div className='about_sub_title'>
                <p>{intl.formatMessage({id:'AboutPage.subTitle1'})}</p>
                <p>{intl.formatMessage({id:'AboutPage.subTitle1.description'})}</p>
                <p>{intl.formatMessage({id:'AboutPage.subTitle1.description1'})}</p>
                <p>{intl.formatMessage({id:'AboutPage.subTitle1.description2'})}</p>
              </div>
              <div className='about_sub_title'>
                <p>{intl.formatMessage({id:'AboutPage.subTitle2'})}</p>
                <p>1. {intl.formatMessage({id:'AboutPage.subTitle2.description'})}</p>
                <p>  •  {intl.formatMessage({id:'AboutPage.subTitle2.subDescription'})}</p>
                <p>  •	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription1'})}</p>
                <p>2. {intl.formatMessage({id:'AboutPage.subTitle2.description1'})}</p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription2'})}</p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription3'})}</p>
                <p>3. <strong>{intl.formatMessage({id:'AboutPage.subTitle2.description2'})}</strong></p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription4'})}</p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription5'})}</p>
                <p>4. {intl.formatMessage({id:'AboutPage.subTitle2.description3'})}</p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription6'})}</p>
                <p>•	{intl.formatMessage({id:'AboutPage.subTitle2.subDescription7'})}</p>
              </div>
              <div className='about_desc'>
                <p>{intl.formatMessage({id:'AboutPage.description'})}</p>
              </div>


            </div>
            <div className="aboutImage">
              <IconAboutSvg />
            </div>
          </div>
      </div>
    </Page>
    </LayoutSingleColumn>

  );
};

export default AboutUsPage;
